// we are storing the token in the local storage its using only when we use auth token instead of bearer token

const GetAccessToken = () => {
  let accessToken = "";
  if (localStorage.getItem("_status")) {
    const obj = JSON.parse(localStorage.getItem("_status"));
    accessToken = obj._tok;
  }
  return accessToken;
};

export { GetAccessToken };
